import { component, debounce, action, getter, prop } from '../../../decorators';

import { CLIPS_SEARCH } from '../../../store/actions';

import QUERY_MIXIN from './query-mixin';

import FilterInput from '../../../components/common/filter-input/filter-input.vue';
import Fields from './list-of-fields/list-of-fields.vue';

import l10n from '../../../transformers/l10n';

const DEBOUNCE_TIMEOUT = 500;

@component({
   components: { FilterInput, Fields },
   mixins: [ QUERY_MIXIN ]
})
export default class SearchField {
   @prop({ type: Boolean, default: () => false }) inflow

   filter = ''

   @getter() searchString
   @getter() isLoadingClips

   @action(CLIPS_SEARCH) changeSearch

   get placeholder() {
      return l10n('search-fields.placeholder');
   }

   @debounce(DEBOUNCE_TIMEOUT)
   changeSearchDebounced() {
      this.search();
   }

   onChangedFilter(filter) {
      this.filter = filter;
      if (!this.inflow) {
         this.changeSearchDebounced();
      }
   }

   search() {
      this.changeSearch(this.filter);
   }

   created() {
      this.filter = this.searchString;
   }
}
